module.exports = __webpack_public_path__ + "img/credit-card.0fb4e0a1.png";